const colors = [
    'rgba(3,103,163,1)',
    'rgba(10,128,190,1)',
    'rgba(13,159,196,1)',
    'rgba(27,168,188,1)',
    'rgba(77,170,113,1)',
    'rgba(96,180,82,1)',
    'rgba(155,196,55,1)',
    'rgba(232,228,43,1)',
    'rgba(255,175,68,1)',
    'rgba(254,97,66,1)',
    'rgba(240,82,70,1)',
    'rgba(218,51,36,1)',
    'rgba(220,28,73,1)',
    'rgba(227,82,139,1)',
    'rgba(133,44,126,1)',
    'rgba(74,35,116,1)'
]

function getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min +1)) + min;
}

export function getRandomColor(int) {
    return colors[int]
}

